import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the divisionAnalysis state domain
 */

const selectTeamAnalysisDomain = (state) =>
  state.get("teamAnalysis", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsLoading = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("isLoading"))

export const makeSelectDivisions = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("divisions"))

export const makeSelectDimensions = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("dimensions"))

export const makeSelectShowHistory = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("show_history"))

export const makeSelectSwitchMoreDimensions = () =>
  createSelector(selectTeamAnalysisDomain, (state) =>
    state.get("switchMoreDimensions")
  )

export const makeSelectDivisionsDrillDown = () =>
  createSelector(selectTeamAnalysisDomain, (state) =>
    state.get("divisions_drilldown")
  )

export const makeSelectMetric = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("metric"))

export const makeSelectLevels = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("levels"))

export const makeSelectDivisionsFilter = () =>
  createSelector(selectTeamAnalysisDomain, (state) =>
    state.get("divisions_filter")
  )

export const makeSelectGraphicBars = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("graphicBars"))

export const makeSelectIsLoadingGraphicBars = () =>
  createSelector(selectTeamAnalysisDomain, (state) =>
    state.get("isLoadingGraphicBars")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectTeamAnalysisDomain, (state) => state.get("measureInfo"))

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectTeamAnalysisDomain, (state) =>
    state.get("measureColorRange")
  )
/**
 * Default selector used by DivisionAnalysis
 */

const makeSelectTeamAnalysis = () =>
  createSelector(selectTeamAnalysisDomain, (substate) => substate.toJS())

export default makeSelectTeamAnalysis
export { selectTeamAnalysisDomain }
